import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MapViewModule } from './components/map-view/map-view.module';

const routes: Routes = [
  { path: 'map/:namespace/:routes', component: MapViewModule },
  { path: '', pathMatch:'full', redirectTo: 'map' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
